<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      <!------------------------search----------------------> 
        <el-form :inline="true" class="backborder1 demo-form-inline" ref="query" :model="query" size="small">
          <el-form-item>
            <el-select v-model="query.district_id" filterable placeholder="按区域" clearable>
              <el-option label="不选区域" value="0"></el-option>
              <el-option v-for="(item,index) in searchdistrictlists" :label="item.district_name" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="query.groupid" filterable placeholder="按分类" clearable>
              <el-option label="不分类" value="0"></el-option>
              <el-option v-for="(item,index) in classlists" :label="item.groupname" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="query.clerkid" filterable placeholder="按销售员" clearable>
              <el-option label="不选销售员" value="0"></el-option>
              <el-option v-for="(item,index) in clerklists" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="简称 / 客户名称 / 手机号码 / 地址" v-model="query.key" @keyup.enter.native="getList" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" round  @click="query.p = 1 ,getList()">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" round  @click="addDialog" v-if="actionauth.base_customer_add=='true'">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" round  @click="addmoreDialog" v-if="actionauth.base_customer_add=='true'">批量新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" round  @click="showClassDialog">分类管理</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" round  @click="districtDialog">区域管理</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" round  @click="levelDialog">等级管理</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" round  @click="getexportcustomer">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" round  @click="mergecustomer">合并客户</el-button>
          </el-form-item>
        </el-form>
      <!------------------------search end---------------------->

      <!------------------------class list---------------------->
        <el-dialog title="客户分类管理" :visible.sync="classDialog">
        <el-form :inline="true" class="demo-form-inline" size="medium">
            <el-form-item v-if="actionauth.base_customer_cate_add=='true'">
                <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="createClassDialog = true">新增客户分类</el-button>
            </el-form-item>
        </el-form>
          <el-table :data="classlists" style="width: 100%">
            <el-table-column label="客户分类名称" prop="groupname"></el-table-column>
            <el-table-column prop="discount" label="折扣（%）" width="100" align="center">
                <template slot-scope="scope">
                    <el-input size="medium" v-model="typelists[scope.$index]"  @blur="changerate(scope.$index,scope.row)"></el-input>
                </template slot-scope="scope">
            </el-table-column>
            
            <el-table-column prop="istype" label="折扣/商品会员价（折扣方式）" width="125" align="center">
          	    <template slot-scope="scope">
              	    <el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="istype[scope.$index]"  @change="changedistype(scope.$index,scope.row)"></el-switch>
          	    </template>
            </el-table-column>
            
            <el-table-column label="操作" width="160" v-if="actionauth.base_customer_cate_edit=='true' || actionauth.base_customer_cate_del=='true'" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="small" circle icon="el-icon-edit"  @click="editClassDialog(scope.row)" v-if="actionauth.base_customer_cate_edit=='true'"></el-button>
                <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delClass(scope.row)" v-if="actionauth.base_customer_cate_del=='true'"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>
      <!------------------------class list end---------------------->

      <!------------------------add class---------------------->
        <el-dialog title="新增客户分类" :visible.sync="createClassDialog" width="30%">
          <el-form ref="createclass" :model="createclass" :rules="classrules" label-width="100px" size="medium">
            <el-col :span="22">
              <el-form-item label="分类名称" prop="groupname">
                <el-input v-model="createclass.groupname"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="createClassDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="createClassLoading" @click="createClassSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------add class end---------------------->

      <!------------------------edit class---------------------->
        <el-dialog title="编辑分类" :visible.sync="updateClassDialog" width="30%">
          <el-form ref="updateclass" :model="updateclass" :rules="classrules" label-width="100px" size="medium">
            <el-col :span="22">
              <el-form-item label="分类名称" prop="groupname">
                <el-input v-model="updateclass.groupname"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="updateClassDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="updateClassLoading" @click="updateClassSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------edit class end---------------------->

      <!------------------------add---------------------->
        <el-dialog title="新增客户" :visible.sync="createDialog">
          <el-form ref="create" :model="create" :rules="rules" label-width="100px" size="medium">
            <el-col :span="24">
              <el-col :span="13" v-if="isshowshop==1">
                <el-form-item label="客户名称" prop="name">
                  <el-input v-model="create.name" @blur="simpleSlice"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="23" v-if="isshowshop!=1">
                <el-form-item label="客户名称" prop="name">
                  <el-input v-model="create.name" @blur="simpleSlice"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" v-if="isshowshop==1">
                <el-form-item label="所属店铺" prop="shopname">
                  <el-input v-model="create.shopname" @focus="chooseShop"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="13">
                <el-form-item label="客户简称" prop="simple">
                  <el-input v-model="create.simple"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="名称拼音码" prop="pym">
                  <el-input v-model="create.pym"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="13">
                <el-form-item label="客户分类">
                  <el-select v-model="create.groupid" placeholder="请选择客户分类" prop="groupid">
                    <el-option label="不分类" value="0"></el-option>
                    <el-option v-for="(item,index) in classlists" :label="item.groupname" :value="item.id" :key="index"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="结算期限" prop="period">
                  <el-input v-model="create.period"><template slot="append">天</template></el-input>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="13">
	              <el-form-item label="所在城市" prop="cityid">
	              	  <el-cascader :options="citys" v-model="create.cityids"></el-cascader>
	              </el-form-item>
              </el-col>
              <el-col :span="10">
	              <el-form-item label="所在区域" prop="district_name">
	              	  <el-input v-model="create.district_name" readonly  @focus="selectdistricts"></el-input>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="13">
	              <el-form-item label="客户编码" prop="number">
	              	  <el-input v-model="create.number"></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="10">
	              <el-form-item label="负责销售员" prop="clerkid">
	              	  <el-select v-model="create.clerkid" placeholder="请选择销售员" clearable>
                      	  <el-option v-for="(item,index) in clerklists" :label="item.name" :value="item.id" :key="index"></el-option>
                  	  </el-select>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="13">
                <el-form-item label="详细地址">
                  <el-input v-model="create.address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="获取所在位置">
                  <el-input v-model="create.position" @focus="getmapinfos()" readonly></el-input>
                </el-form-item>
              </el-col>                  
            </el-col>
            
            <el-col :span="24">
              <el-col :span="13">
                <el-form-item label="联系电话">
                  <el-input v-model="create.phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="期初应收款" prop="receivable">
                  <el-input v-model="create.receivable"></el-input>
                </el-form-item>
              </el-col>
              <!--
              <el-col :span="8">
                <el-form-item label="期初预收款" prop="advance">
                  <el-input v-model="create.advance"></el-input>
                </el-form-item>
              </el-col>
              -->
            </el-col>
			
			      <el-col :span="24">
			        <el-col :span="13">
                <el-form-item label="应收款上限" prop="maxreceivable">
                  <el-input v-model="create.maxreceivable"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
	            <el-form-item label="预存款" prop="balance">
	              <el-input v-model="create.balance" :disabled="true"></el-input>
	            </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="23">
              <el-form-item label="备注">
                <el-input type="textarea" v-model="create.note"></el-input>
              </el-form-item>
            </el-col>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="createDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="createLoading" @click="createSave">保 存</el-button>
          </div>
        </el-dialog>
        
        <!-----------  批量新增客户信息 --------------->
        <el-dialog title="批量新增客户" :visible.sync="morecustomerDialog" width="98%" top="5vh">
        	<el-tag type="danger">温馨提示：上传客户信息时请戳下方使用系统模板，谢绝使用自定义模板</el-tag>
          	<el-form width="100%" style="margin-top:10px">
                <el-col :span="10">
	                <el-form-item>
	                	<input id="fileupload" type="file" @change="importfile(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
	                	<el-button type="primary" size="small" icon="el-icon-download" @click="getdownmoremodel">下载模板</el-button>
	                	<el-button type="warning" size="small" icon="el-icon-upload2" @click="getaddmoremodel">上传数据</el-button>
	                </el-form-item>
                </el-col>
          	</el-form>
          	<el-table :data="inputcustomers" border v-loading="inputlistLoading">
	            <el-table-column prop="name" label="客户名称" align="center"></el-table-column>
	            <el-table-column prop="simple" label="客户简称" align="center"></el-table-column>
	            <el-table-column prop="number" label="客户编号" width="100" align="center"></el-table-column>
	            <el-table-column prop="phone" label="联系电话" width="115" align="center"></el-table-column>
	            <el-table-column prop="cate" label="客户分类" align="center"></el-table-column>
	            <el-table-column prop="clerk" label="负责销售员" align="center"></el-table-column>
	            <el-table-column prop="maxreceivable" label="应收款上限" align="center"></el-table-column>
	            <el-table-column prop="receivable" label="期初应收款" align="center"></el-table-column>
	            <el-table-column prop="advance" label="预存款" align="center"></el-table-column>
	            <el-table-column prop="city" label="所在城市" align="center"></el-table-column>
	            <el-table-column prop="district" label="所在区域" align="center"></el-table-column>
	            <el-table-column prop="address" label="地址" align="center"></el-table-column>
	            <el-table-column prop="note" label="备注" align="center"></el-table-column>      
        	</el-table>

            <div slot="footer" class="dialog-footer">
            	<el-button size="medium" @click="morecustomerDialog = false">取 消</el-button>
            	<el-button size="medium" type="primary" :loading="createmoreLoading" @click="createmoreSave">保 存</el-button>
            </div>
        </el-dialog>
                
        <!------------------------add end---------------------->
        <div class="backborder2" style="margin-top:10px">
	        <el-table :data="lists" v-loading="listLoading">
              <el-table-column prop="id" label="id" width="100" align="center" />
              <el-table-column prop="name" label="客户信息">
                  <template slot-scope="scope">
                      <div class="cz-customer-infos-out">
                          <div class="cz-customer-infos-out-imgs">
                              <img :src="scope.row.thumb!='' ? GLOBAL.staticUrl+scope.row.thumb : require('../../assets/customer/customer_default.png')" />
                              <el-tooltip class="item" effect="dark" content="客户来源：线上商城" placement="top">
                              <div class="cz-customer-data-from" v-if="scope.row.datafrom==1"><img src="../../assets/customer/customer_shop.png" /></div>
                              </el-tooltip>
                              <el-tooltip class="item" effect="dark" content="客户来源：天猫" placement="top">
                              <div class="cz-customer-data-from" v-if="scope.row.datafrom==2"><img src="../../assets/customer/customer_taobao.png" /></div>
                              </el-tooltip>
                              <el-tooltip class="item" effect="dark" content="客户来源：抖音" placement="top">
                              <div class="cz-customer-data-from" v-if="scope.row.datafrom==3"><img src="../../assets/customer/customer_dshop.png" /></div>
                              </el-tooltip>
                              <el-tooltip class="item" effect="dark" content="客户来源：拼多多" placement="top">
                              <div class="cz-customer-data-from" v-if="scope.row.datafrom==4"><img src="../../assets/customer/sell_pindd.png" /></div>
                              </el-tooltip>
                          </div>
                          <div class="cz-customer-infos-content">
                              <div class="cz-customer-infos-main">
                                  <div class="cz-customer-infos-main-name">{{scope.row.name}}</div>
                                  <div class="cz-customer-infos-main-phone">{{scope.row.phone}}</div>
                                  <div class="cz-customer-infos-main-district">{{scope.row.district_name=='不选择区域' ? '' : scope.row.district_name}}</div>
                              </div>
                          </div>
                      </div>
                  </template>
              </el-table-column>

              <el-table-column label="对接销售员" prop="sellername" width="170" align="left">
                  <template slot-scope="scope">
                      <div class="cz-customer-infos-cate">
                          <img src="../../assets/customer/customer_seller.png"/>
                          <span>{{scope.row.sellername=='无' ? '' : scope.row.sellername}}</span>
                      </div>
                  </template>
              </el-table-column>

              <el-table-column label="客户分类 / 等级" width="180">
                  <template slot-scope="scope">
                      <div class="cz-customer-infos-cate">
                          <img src="../../assets/customer/customer_cate.png"/>
                          <span>{{scope.row.groupname=='无分类' ? '暂无分类' : scope.row.groupname}}</span>
                      </div>
                      <div class="cz-customer-infos-cate">
                          <img src="../../assets/customer/customer_level.png"/>
                          <span>{{scope.row.levelname=='' ? '暂无等级' : scope.row.levelname}}</span>
                      </div>
                  </template>
              </el-table-column>

              <el-table-column label="地址信息详情" prop="sellername" max-width="500" align="left">
                  <template slot-scope="scope">
                      <div class="cz-customer-infos-cate-address">
                          <img src="../../assets/customer/customer_area.png"/>
                          <span>{{scope.row.cityname}}{{!scope.row.address ? '' : ' | '+scope.row.address}}</span>
                      </div>
                  </template>
              </el-table-column>
    
	            <el-table-column label="操作" width="100" v-if="actionauth.base_customer_edit=='true' || actionauth.base_customer_del=='true'" align="center">
		            <template slot-scope="scope">

                    <el-dropdown>
							          <el-button type="warning" size="mini" icon="el-icon-arrow-down" circle></el-button>
							          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="depositCurrent(scope.row)" v-if="actionauth.config_manager_deposit=='true'">查看预存款充值</el-dropdown-item>
                            <el-dropdown-item @click.native="editCurrent(scope.row)" v-if="actionauth.base_customer_edit=='true'">编辑客户</el-dropdown-item>
                            <el-dropdown-item @click.native="delCurrent(scope.row)" v-if="actionauth.base_customer_del=='true'">删除客户</el-dropdown-item>
                            <el-dropdown-item @click.native="kingdeesellsubmit(scope.row)" v-if="iskingdee==1" :disabled="scope.row.kingdeesubmit==1 ? true : false">同步数据到金蝶</el-dropdown-item>
                        </el-dropdown-menu>
						        </el-dropdown>

                    <!--
                    <el-tooltip class="item" effect="dark" content="查看客户跑店记录" placement="top">
                        <el-button type="warning" icon="el-icon-view" size="mini" circle @click="lookruns(scope.row)"></el-button>
                    </el-tooltip>
                    -->

		            </template>
	            </el-table-column>
	        </el-table>
	        <div class="block">
	        <!--分页begin-->
	        <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	        </el-pagination>
	        <!--分页end-->
	        </div>
        </div>

      <!------------------------edit---------------------->
        <el-dialog title="编辑客户信息" :visible.sync="updateDialog">
          <el-form ref="update" :model="update" :rules="rules" label-width="100px" size="medium">
            <el-col :span="24">
              <el-col :span="13" v-if="isshowshop==1">
                <el-form-item label="客户名称" prop="name">
                  <el-input v-model="update.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="23" v-if="isshowshop!=1">
                <el-form-item label="客户名称" prop="name">
                  <el-input v-model="update.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" v-if="isshowshop==1">
                <el-form-item label="所属店铺" prop="shopname">
                  <el-input v-model="update.shopname" @focus="chooseUpdateShop"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="13">
                <el-form-item label="客户简称" prop="simple">
                  <el-input v-model="update.simple"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="名称拼音码" prop="pym">
                  <el-input v-model="update.pym"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="13">
                <el-form-item label="客户分类">
                  <el-select v-model="update.groupid" placeholder="请选择客户分类" prop="groupid">
                    <el-option label="不分类" value="0"></el-option>
                    <el-option v-for="(item,index) in classlists" :label="item.groupname" :value="item.id" :key="index"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="结算期限" prop="period">
                  <el-input v-model="update.period"><template slot="append">天</template></el-input>
                </el-form-item>
              </el-col>
            </el-col>
            
            <el-col :span="24">
              <el-col :span="13">
	              <el-form-item label="所在城市" prop="cityid">
	              	  <el-cascader :options="citys" v-model="update.cityids"></el-cascader>
	              </el-form-item>
              </el-col>
              <el-col :span="10">
	              <el-form-item label="所在区域" prop="district_name">
	              	  <el-input v-model="update.district_name" readonly  @focus="selectdistricts"></el-input>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="13">
	              <el-form-item label="客户编码" prop="number">
	              	  <el-input v-model="update.number"></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="10">
	              <el-form-item label="负责销售员" prop="clerkid">
	              	  <el-select v-model="update.clerkid" placeholder="请选择销售员" clearable>
                      	  <el-option v-for="(item,index) in clerklists" :label="item.name" :value="item.id" :key="index"></el-option>
                  	  </el-select>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="13">
                <el-form-item label="地址">
                  <el-input v-model="update.address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="获取所在位置">
                  <el-input v-model="update.position" @focus="getmapinfos()" readonly></el-input>
                </el-form-item>
              </el-col>   
            </el-col>
            <el-col :span="24">
              <el-col :span="13">
                <el-form-item label="联系电话">
                  <el-input v-model="update.phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="应收款合计">
                  <el-input v-model="update.receivable" :readonly='true'></el-input>
                </el-form-item>
              </el-col>
              <!--
              <el-col :span="8">
                <el-form-item label="预收款合计">
                  <el-input v-model="update.advance" :readonly='true'></el-input>
                </el-form-item>
              </el-col>
              -->
            </el-col>

            <el-col :span="24">
            	 <el-col :span="13">
	                <el-form-item label="应收款上限" prop="maxreceivable">
	                  <el-input v-model="update.maxreceivable"></el-input>
	                </el-form-item>
	             </el-col>
            	 <el-col :span="10">
	                <el-form-item label="预存款">
	                  <el-input v-model="update.balance" :disabled="true"></el-input>
	                </el-form-item>
                </el-col>
            </el-col>
            
            <el-col :span="24">
	            <el-form-item label="备注">
	              <el-input type="textarea" v-model="update.note"></el-input>
	            </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="updateDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------edit end---------------------->

      <!------------------------选择店铺---------------------->
        <el-dialog title="选择店铺" :visible.sync="chooseShopDialog" width="70%" top="1vh">
        <el-form :inline="true" size="medium">
          <el-form-item ref="choose" :model="choose">
            <el-input placeholder="请输入关键字" v-model="choose.key" ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getShopList">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="shoplists" v-loading="chooseShopLoading">
          <el-table-column prop="id" label="序号" width="120">
          </el-table-column>
          <el-table-column prop="shopname" label="名称" width="220">
          </el-table-column>
          <el-table-column prop="address" label="地址">
          </el-table-column>
          <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="primary" size="small" circle icon="el-icon-check" @click="chooseShopSave(scope.row)"></el-button>
          </template>
          </el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageChooseSizeChange"
            @current-change="pageChooseCurrentChange"
            :current-page="choose.p"
            :page-sizes="[10, 20, 50]"
            :page-size="choose.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="choose_total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        </el-dialog>
        <!--------------------------choose shopid end-------------------------------------->

      <!------------------------更新选择店铺---------------------->
        <el-dialog title="选择店铺" :visible.sync="chooseUpdateShopDialog" width="70%" top="1vh">
        <el-form :inline="true">
          <el-form-item ref="choose" :model="choose">
            <el-input placeholder="请输入关键字" size="25" v-model="choose.key" ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getShopList">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="shoplists" v-loading="chooseShopLoading">
          <el-table-column prop="id" label="序号" width="120">
          </el-table-column>
          <el-table-column prop="shopname" label="名称" width="220">
          </el-table-column>
          <el-table-column prop="address" label="地址">
          </el-table-column>
          <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-check" @click="chooseUpdateShopSave(scope.row)"></el-button>
          </template>
          </el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageChooseSizeChange"
            @current-change="pageChooseCurrentChange"
            :current-page="choose.p"
            :page-sizes="[10, 20, 50]"
            :page-size="choose.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="choose_total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        </el-dialog>
        <!--------------------------choose shopid end-------------------------------------->
        
        <!------------------------客户区域管理列表 start---------------------->
        <el-dialog title="客户区域管理" :visible.sync="createdistrictDialog" width="50%">
        <el-form :inline="true" class="demo-form-inline" size="medium">
            <el-form-item ref="choose" :model="choose">
            	<el-input placeholder="请输入关键字" v-model="disstrictquery.key" ></el-input>
            </el-form-item>
            <el-form-item>
            	<el-button type="primary" icon="el-icon-search" @click="districtDialog">查询</el-button>
            </el-form-item>
            <el-form-item v-if="actionauth.base_customer_area_add=='true'">
            	<el-button type="primary" icon="el-icon-circle-plus-outline"  @click="addistrictDialog = true">新增客户区域</el-button>
            </el-form-item>
        </el-form>
          <el-table :data="districtlists" v-loading="districtlistsLoading" style="width: 100%">
            <el-table-column label="区域名称" prop="district_name" style="width:90%"></el-table-column>
            <el-table-column label="操作" style="width:10%" align="center" v-if="actionauth.base_customer_area_edit=='true' || actionauth.base_customer_area_del=='true'">
                <template slot-scope="scope">
                	<el-button type="primary" size="small" circle icon="el-icon-edit"  @click="editdistrictDialog(scope.row)" v-if="actionauth.base_customer_area_edit=='true'"></el-button>
                	<el-button type="danger" size="small" circle icon="el-icon-delete" @click="deldistrict(scope.row)" v-if="actionauth.base_customer_area_del=='true'"></el-button>
                </template>
            </el-table-column>
          </el-table>
          <div class="block">
          <!--分页begin-->
          <el-pagination
            @size-change="districtChooseSizeChange"
            @current-change="districtChooseCurrentChange"
            :current-page="disstrictquery.p"
            :page-sizes="[10, 20, 50]"
            :page-size="disstrictquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="district_total_rows">
          </el-pagination>
          <!--分页end-->
          </div>
        </el-dialog>
        <!------------------------客户区域管理列表 end---------------------->
        
        <!------------------------添加客户区域管理 start---------------------->
        <el-dialog title="添加客户区域管理" :visible.sync="addistrictDialog" width="30%">
        	<el-input placeholder="请输入区域名称" size="medium" v-model="adddistrict.name"></el-input>
        	<div slot="footer" class="dialog-footer">
	            <el-button size="medium" @click="addistrictDialog = false">取 消</el-button>
	            <el-button size="medium" type="primary" :loading="adddistrictLoading" @click="districtSave">保 存</el-button>
            </div>
        </el-dialog>
        <!------------------------添加客户区域管理 end---------------------->
        
        <!------------------------编辑客户区域管理 start---------------------->
        <el-dialog title="编辑客户区域管理" :visible.sync="editdisDialog" width="30%">
        	<el-input placeholder="请输入区域名称" size="medium" v-model="editdistrict.name"></el-input>
        	<div slot="footer" class="dialog-footer">
	            <el-button size="medium" @click="editdisDialog = false">取 消</el-button>
	            <el-button size="medium" type="primary" :loading="editdistrictLoading" @click="editdistrictSave">保 存</el-button>
            </div>
        </el-dialog>
        <!------------------------编辑客户区域管理 end---------------------->
        
        <!------------------------选择客户区域管理列表 start---------------------->
        <el-dialog title="选择客户区域管理" :visible.sync="selectdistrictDialog" width="50%">
	        <el-form :inline="true" class="demo-form-inline">
	            <el-form-item ref="choose" :model="choose">
	            	<el-input placeholder="请输入关键字" size="25" v-model="selectdisstrictquery.key" ></el-input>
	            </el-form-item>
	            <el-form-item>
	            	<el-button type="primary" icon="el-icon-search" @click="selectdistricts">查询</el-button>
	            </el-form-item>
	            <el-form-item>
            		<el-button type="primary" icon="el-icon-circle-plus-outline"  @click="addistrictDialog = true">新增客户区域</el-button>
            	</el-form-item>
	        </el-form>
            <el-table :data="selectdistrict" v-loading="selectdistrictlistsLoading" style="width: 100%">
	            <el-table-column label="区域名称" prop="district_name" style="width:90%"></el-table-column>
	            <el-table-column label="操作" style="width:10%" align="center">
	              <template slot-scope="scope">
	                <el-button type="primary" size="mini" icon="el-icon-check"  @click="ensuredistrict(scope.row)">确定</el-button>
	              </template>
	            </el-table-column>
            </el-table>
          <div class="block">
          <!--分页begin-->
          <el-pagination
            @size-change="depositSizeChange"
            @current-change="depositCurrentChange"
            :current-page="deposit.p"
            :page-sizes="[10, 20, 50]"
            :page-size="deposit.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="select_district_total_rows">
          </el-pagination>
          <!--分页end-->
          </div>
        </el-dialog>
        <!------------------------选择客户区域管理列表 end---------------------->
        
        <!------------------------预存款充值列表 start---------------------->
        <el-dialog :title="depositname" :visible.sync="depositDialog" width="80%" top="5vh">
        	<el-form :inline="true" class="demo-form-inline" size="medium">
        		<el-form-item>
	        		<el-select v-model="deposit.type" placeholder="请选择分类" size="10">
	                    <el-option label="不选分类" value="0"></el-option>
	                    <el-option label="订单结算" value="1"></el-option>
	                    <el-option label="客户结清欠款" value="2"></el-option>
	                    <el-option label="订单部分退款" value="3"></el-option>
	                    <el-option label="订单全部退款" value="4"></el-option>
	                    <el-option label="预存款充值" value="5"></el-option>
	                </el-select>
                </el-form-item>
	            <el-form-item>
	            	<el-date-picker	v-model="deposit.date" type="daterange" width="290px"
		              	range-separator="至"
		              	start-placeholder="开始日期"
		              	end-placeholder="结束日期"
		              	value-format="yyyy-MM-dd">
		            </el-date-picker>
	            </el-form-item>
	            <el-form-item>
	            	<el-button type="primary" icon="el-icon-search" @click="getdeposit">查询</el-button>
	            </el-form-item>
	            <el-form-item>
            		<el-button type="primary" icon="el-icon-circle-plus-outline"  @click="adddeposit">充值</el-button>
            	</el-form-item>
            	<el-form-item>
            		<el-tag type="danger" style="padding:0 10px 33px 10px;line-height:32px">剩余预存款：￥{{depositbalance}}</el-tag>
            	</el-form-item>
	        </el-form>
	        
	        <el-table :data="depositlists" v-loading="depositLoading" style="width:100%">
	            <el-table-column label="单号" prop="sn" width="150"></el-table-column>
	            <el-table-column label="客户名称" prop="customername" width="230"></el-table-column>
	            <el-table-column label="类型" prop="type" width="160"></el-table-column>
                <el-table-column label="金额" width="120">
	                <template slot-scope="scope">
						        <span v-if="scope.row.total>=0" style="color:#67C23A">{{scope.row.total}}</span>
						        <span v-if="scope.row.total<0" style="color:#F56C6C">{{scope.row.total}}</span>
	                </template>
                </el-table-column>
	            <el-table-column label="备注" prop="node" width="180"></el-table-column>
	            <el-table-column label="时间" prop="inputtime" align="center"></el-table-column>
            </el-table>
            
            <div class="block">
	            <!--分页begin-->
	            <el-pagination
		            @size-change="depositSizeChange"
		            @current-change="depositCurrentChange"
		            :current-page="deposit.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="deposit.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="deposit_total_rows">
	            </el-pagination>
	            <!--分页end-->
            </div>
	        
        </el-dialog>
        <!------------------------预存款充值列表 end---------------------->
        
        <!------------------------添加预存款 start---------------------->
        <el-dialog title="添加预存款" :visible.sync="addpositDialog" width="23%" top="20vh">
        	<el-form :inline="true" class="demo-form-inline">
        		<el-col :span="22">
	                <el-form-item label="金额">
	                	<el-input v-model="savedeposit.balance" size="18"></el-input>
	                </el-form-item>
            	</el-col>
            	<el-col :span="22">
	                <el-form-item label="备注">
	                	<el-input type="textarea" v-model="savedeposit.node" rows="4"></el-input>
	                </el-form-item>
            	</el-col>
        	</el-form>
        	<div slot="footer" class="dialog-footer">
	            <el-button @click="addpositDialog = false">取 消</el-button>
	            <el-button type="primary" :loading="addpositLoading" @click="depositSave">保 存</el-button>
          	</div>
        </el-dialog>
        <!------------------------添加预存款 end------------------------>
        
        <!-------------- 展示地图信息 ------------------->
	    <el-dialog title="地图信息展示" :visible.sync="showmapDialog" top="5vh" width="55%">	    
	    	<template> 
			    <baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler" @click="getlocalposition" :scroll-wheel-zoom="true" v-loading="mapLoading">
    				<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="false" :autoLocation="true" :locationIcon="{size: {width: 18, height: 18}}" @locationSuccess="getLoctionSuccess" @locationError="getLocationError"></bm-geolocation>
    				<!-- 自定义定位图标覆盖物 -->
    				<bm-marker :position="markerPoint" :dragging="true" :auto-viewport='true' animation="BMAP_ANIMATION_BOUNCE"  v-if="initLocation"></bm-marker>
    				<!-- 左边放大缩小工具 -->
    				<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
    				<bm-control :offset="{width: '100%', height: '10px'}">
			            <bm-auto-complete v-model="maplocation" :sugStyle="{zIndex: 999999}">
			            	<input type="text" placeholder="请输入搜索关键字" class="serachinput">
			            </bm-auto-complete>
			        </bm-control>
			        <bm-local-search :keyword="maplocation" :auto-viewport="true" style="width:0px;height:0px;overflow: hidden;" @searchcomplete="markersset"></bm-local-search>   				
  				</baidu-map>
  				<el-button type="primary" @click="gobackcenter">返回中心位置</el-button>	    
			</template>			
			<div slot="footer" class="dialog-footer">
            	<el-button @click="showmapDialog = false">取 消</el-button>
            	<el-button type="primary" @click="savelocation">保 存</el-button>
            </div>
	    </el-dialog>
	    
	    <!-- 导出客户信息 -->
	    <el-dialog title="导出商品销售信息确认" :visible.sync="exportdataDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="productoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="exportcustomers" border v-loading="exportdataLoading">
		      	  	<el-table-column prop="district_name" label="区域" width="90"></el-table-column>
		          	<el-table-column prop="name" label="客户名称"></el-table-column>
		          	<el-table-column prop="number" label="客户编号"></el-table-column>
		          	<el-table-column prop="phone" label="客户电话" align="center"></el-table-column>
		          	<el-table-column prop="address" label="客户地址" align="center"></el-table-column>
		          	<el-table-column prop="groupname" label="客户分类" align="center"></el-table-column>
		          	<el-table-column prop="clerkname" label="销售员" align="center"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="exportdataDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="productoutput">确认导出</el-button>
		      </div>	                
	    </el-dialog>


      <!-- 合并客户信息 -->
      <el-dialog title="合并客户信息" :visible.sync="mergeDialog" width="40%" top="10vh">
          <div class="merge-custoers-notice">温馨提示：此功能主要用于将两个重复添加的客户信息合并成一个（包括被合并客户所添加的销售出库单、商品退货入库单）</div>
          <div class="merge-customer">
              <div style="float:left;width:100%"><el-button type="warning" round size="mini" icon="el-icon-s-tools" style="float:right;margin-bottom:10px" @click="changecustomer">转换位置</el-button></div>
              <div class="merge-main">
                  <span class="merge-title">待合并客户（合并后删除）</span>
                  <a class="mergecontent" @click="getmergecustomer(1)">
                    <span class="nomerge" v-if="mergequery.oldid==''">请选择客户</span>
                    <span class="nomerge" v-if="mergequery.oldid > 0">{{mergequery.olddata.name}}</span>
                    <span class="nomerge" v-if="mergequery.oldid > 0">销售出库单数量：{{mergequery.olddata.sells}}</span>
                    <span class="nomerge" v-if="mergequery.oldid > 0">退货入库单数量：{{mergequery.olddata.refunds}}</span>
                  </a>
              </div>
              <div class="merge-other">
                  <span class="merge-title">合并客户（合并后保留）</span>
                  <a class="mergecontent" @click="getmergecustomer(2)">
                    <span class="nomerge" v-if="mergequery.newid==''">请选择客户</span>
                    <span class="nomerge" v-if="mergequery.newid > 0">{{mergequery.newdata.name}}</span>
                    <span class="nomerge" v-if="mergequery.newid > 0">销售出库单数量：{{mergequery.newdata.sells}}</span>
                    <span class="nomerge" v-if="mergequery.newid > 0">退货入库单数量：{{mergequery.newdata.refunds}}</span>
                  </a>
              </div>
          </div>
          <div slot="footer" class="dialog-footer">
              <el-button type="danger" size="small" @click="savemerge">保 存</el-button>
		          <el-button size="small" @click="mergeDialog=false">取 消</el-button>
		      </div>	  
      </el-dialog>

      <!-- 客户信息列表 -->
      <el-dialog title="获取客户信息" :visible.sync="mergecustomerDialog" width="50%" top="5vh">
          <el-form :inline="true" size="small">
            <el-form-item><el-input placeholder="请输入关键字" clearable v-model="mergecustomerquery.key" @change="mergechange=true"></el-input></el-form-item>
            <el-form-item><el-button type="primary" icon="el-icon-search" round @click="getmergecustomerdata">查询</el-button></el-form-item>
          </el-form>
          <el-table :data="mergecustomerlists" v-loading="mergecustomerquery.loading">
            <el-table-column prop="name" label="客户名称" align="left"/>
            <el-table-column prop="phone" label="手机" align="center"/>
            <el-table-column prop="sells" label="已开销售单数量" align="center"/>
            <el-table-column prop="refunds" label="已开退货单数量" align="center"/>
            <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button type="success" size="mini" circle icon="el-icon-check" @click="selectcustomer(scope.row)"></el-button>
                </template>
            </el-table-column>
          </el-table>
          <div class="block">
          <!--分页begin-->
            <el-pagination
              @size-change="mergepageSizeChange"
              @current-change="mergepageCurrentChange"
              :current-page="mergecustomerquery.p"
              :page-sizes="[10, 20, 50]"
              :page-size="mergecustomerquery.rollpage"
              layout="total, sizes, prev, pager, next, jumper"
              :total="merge_rows">
            </el-pagination>
            <!--分页end-->
          </div>
      </el-dialog>
        
        
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Customer/index",
      datacenter:this.$cookies.get('datacenter'),
      lists:[],
      listLoading:false,
      isshowshop:2,
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        groupid:'',
        clerkid:'',
        district_id:'',
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      total_rows: 0,
      createDialog: false,
      createLoading: false,
      create: {
        act:'add',
        token:this.$cookies.get('token'),
        name:'',
        number:'',
        shopid:'',
        simple:'',
        pym:'',
        address:'',
        phone:'',
        receivable:'',
        advance:'',
        maxreceivable:'',
        balance:0.00,
        groupid:'',
        period:'',
        note:'',
        cityids:[],
        district_id:0,
        district_name:'不选择区域',
        position:'',
        clerkid:'',
      },
      citys:[],
      updateDialog:false,
      updateLoading:false,
      update: {
        act:'edit',
        token:this.$cookies.get('token'),
        id:'',
        name:'',
        number:'',
        shopid:'',
        shopname:'',
        simple:'',
        pym:'',
        address:'',
        phone:'',
        receivable:'',
        advance:'',
        maxreceivable:'',
        balance:0.00,
        groupid:'',
        period:'',
        note:'',
        cityids:[],
        position:'',
        lng:'',
        lat:'',
        clerkid:'',
      },
      rules: {
        name: [
            { required: true, message: '请输入客户名称', trigger: 'blur' },
        ],
        shopid: [
            { min: 1, max: 10, message: '长度在 1 到 10 个字符'},
            { pattern:/^[0-9]+$/, message: '编号只能为数字'}
        ],
        simple: [
        	{ required: true, message: '请填写客户简称', trigger: 'blur' },
        ],
        pym: [
        	{ required: true, message: '请填写客户拼音码', trigger: 'blur' },
        ],
        groupid: [
        	{ required: true, message: '请选择客户分类', trigger: 'blur' },
        ],
        cityids: [
        	{ required: true, message: '请选择所属城市', trigger: 'blur' },
        ],
        receivable: [
            { pattern:/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/, message: '应收款只能为数值'}
        ],
        advance: [
            { pattern:/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/, message: '预收款只能为数值'}
        ],
        maxreceivable: [
            { pattern:/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/, message: '应收款只能为数值'}
        ]
      },
      classDialog:false,
      createClassDialog:false,
      createClassLoading:false,
      adddistrictLoading:false,
      createclass: {
        act:'addclass',
        token:this.$cookies.get('token'),
        groupname:'',
      },
      classrules: {
        groupname: [
            { required: true, message: '请输入分类名称', trigger: 'blur' },
            { min: 1, max: 20, message: '长度在 1 到 20 个字符'}
        ]
      },
      classlists:[],
      classListLoading:false,
      updateClassDialog:false,
      updateClassLoading:false,
      updateclass: {
        act:'editclass',
        token:this.$cookies.get('token'),
        id:'',
        groupname:'',
      },
      projectData: [{
        project: '基本属性'
      }, {
        project: '辅助属性'
      }, {
        project: '辅助属性'
      }],
      priceNameData:[{
        pricename:'银卡价格'
      },{
        pricename:'金卡价格'
      },{
        pricename:'钻石价格'
      }],
      chooseShopDialog:false,
      chooseShopLoading:false,
      choose_total_rows:0,
      choose:{
        act:'shoplists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      shoplists:[],
      chooseUpdateShopDialog:false,
      createdistrictDialog:false,
      addistrictDialog:false,
      editdisDialog:false,
      editdistrictLoading:false,
      selectdistrictDialog:false,
      selectdistrictlistsLoading:false,
      selectdistrict:[],
      adddistrict: {
        act:'adddistrict',
        token:this.$cookies.get('token'),
        name:'',
      },
      editdistrict: {
        act:'editdistrict',
        token:this.$cookies.get('token'),
        name:'',
        id:'',
      },
      disstrictquery: {
          act:'districtlists',
          token:this.$cookies.get('token'),
          key:'',
          rollpage: 10,
          p: 1
      },
      searchdisstrictquery: {
          act:'districtlists',
          token:this.$cookies.get('token'),
          key:'',
          rollpage: 100000,
          p: 1
      },
      selectdisstrictquery: {
          act:'districtlists',
          token:this.$cookies.get('token'),
          key:'',
          rollpage: 10,
          p: 1
      },
      districtlists:[],
      district_total_rows:0,
      select_district_total_rows:0,
      depositDialog:false,
      depositbalance:0.00,
      deposit: {
      	  act:'depositlog',
      	  token:this.$cookies.get('token'),
      	  date:[],
      	  type:'',
      	  customerid:'',
      	  p: 1,
      	  rollpage: 10,
      },
      savedeposit: {
      	  act:'adddeposit',
      	  token:this.$cookies.get('token'),
      	  balance:0.00,
      	  customerid:'',
      	  node:'',
      },
      depositlists:[],
      depositLoading:false,
      deposit_total_rows:0,
      addpositDialog:false,
      addpositLoading:false,
      
      /** 百度地图相关 **/
      center: {
      	  lng: '',
      	  lat: '',
      },
      markerPoint: {
      	  lng: '',
      	  lat: '',
      },
      zoom:'',
      initLocation: false,
      mapLoading: false,
      showmapDialog:false,
      maplocation:'',
      istype:[],
      typelists:[],
      clerklists:[],
      searchdistrictlists:[],
      morecustomerDialog:false,
      inputcustomers:[],
      inputlistLoading:false,
      createmoreLoading:false,
      exportdataDialog:false,
      exportdataLoading:false,
      exportcustomers:[],     
      exporthead:[],
      exportfield:[],
      exportlists:[],
      exportname:'',
      islineclerk:false,
      iskingdee:false,
      mergeDialog:false,
      mergequery: {
          act:'mergecustomers',
          token:this.$cookies.get('token'),
          loading:false,
          oldid:'',
          olddata:{},
          newid:'',
          newdata:{}
      },
      
      mergecustomerDialog:false,
      mergecustomerquery: {
          act:'getmergecustomers',
          token:this.$cookies.get('token'),
          loading:false,
          mergetype:'',
          key:'',
          p:1,
          ids:[],
          rollpage:10,
      },
      mergechange:false,
      mergecustomerlists:[],
      merge_rows:0,

      
    }
  },
  mounted(){
    this.getactionauth();
    this.getClassList();
    this.getList();
    this.getCitys();
    this.getDefaultcity();
    this.getisshowselectshop();
    this.getclerklists();
    this.getsearchdistrictlsits();
    this.getislineclick(); //获取是否有权限添加线上销售员
    this.checkiskingdee(); //查看当前代理商是否开启金蝶权限 
  },
  methods:{
  
  	/** 获取操作权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

    /** 查看当前代理商是否开启了金蝶权限 **/
	  checkiskingdee() {
		  var resource = this.$resource(this.GLOBAL.domain+"kingdee/index");
			resource.save({act:'isopenkingdee',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.iskingdee=result.iskingdee;
				}
			}).catch((res) => {
				
			});
	  },
    
    //获取职员信息列表
    getclerklists() {
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'getallclerks',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	        }else{
	          this.clerklists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },

    /** 获取是否有权限添加线上销售员信息 **/
    getislineclick() {
        var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
        resource.query({ act:'islineclerk',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
              this.islineclerk=result.islineclerk==0 ? false : true;	          
	        }
        }).catch((res) => {

        });
    },
    
    //获取区域信息列表
    getsearchdistrictlsits() {
    	var resource = this.$resource(this.url);
    	resource.query(this.searchdisstrictquery).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	        }else{
	          this.searchdistrictlists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
  
    //简称
    simpleSlice(){
      this.create.simple=this.create.name.slice(0,6);
      var resource = this.$resource(this.GLOBAL.domain+"Pinyin/index",);
      resource.query({ str:this.create.simple,token:this.$cookies.get('token')}).then((res) => {
        this.create.pym=res.data.Message;
      });
    },
    //重置表单
    reset() {
        this.$refs.create.resetFields();
    },
    
    //新增客户
    addDialog(){
      this.$emit('listenchild',{name:'新增客户',url:'Customeradd'});
      /**
      this.create.position='';
      this.center.lng=116.046671; //地图中心展示的经度
      this.center.lat=40.269514; //地图中心展示的纬度  	
      this.markerPoint.lng='';    	
      this.markerPoint.lat='';
      
      this.create.district_name='不选择区域';
	  this.update.district_id=0;
      this.createDialog=true;
      this.getClassList();
      */
    },
    
    //新增
    createSave(){
      // 主动校验
      this.$refs.create.validate((valid) => {
          if (valid) {
              this.createLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.create).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login');
                    this.$message.error(res.data.Message);
                    this.createLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.createDialog=false;
                    this.createLoading=false;
                    this.reset();
                    this.getList();
                    this.setcreatenull(); //置空客户管理信息
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createDialog=false;
                  this.createLoading=false;
              });
          }else {
            return false;
          }
      });
    },
    //信息列表
    getList(){
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    districtChooseSizeChange(val) {
        this.disstrictquery.rollpage = val;
        this.getdistrictlists();
    },
    districtChooseCurrentChange(val) {
        this.disstrictquery.p = val;
        this.getdistrictlists();
    },
    //选择店铺编号
    chooseShop(){
      this.chooseShopDialog=true;
      this.getShopList();
    },
    chooseUpdateShop(){
      this.chooseUpdateShopDialog=true;
      this.getShopList();
    },
    getShopList(){
      this.chooseShopLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.choose).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.chooseShopLoading = false;
        }else{
          this.shoplists = JSON.parse(Base64.decode(res.data.Data));
          this.choose_total_rows=parseInt(res.data.count);
          this.chooseShopLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.chooseShopLoading=false;
      });
    },
    pageChooseSizeChange(val) {
        this.choose.rollpage = val;
        this.getShopList();
    },
    pageChooseCurrentChange(val) {
        this.choose.p = val;
        this.getShopList();
    },
    
    depositSizeChange(val) {
        this.depositrollpage = val;
        this.getdeposit();
    },
    depositCurrentChange(val) {
        this.deposit.p = val;
        this.getdeposit();
    },
    
    chooseShopSave(item){
      this.create.shopid=item.id;
      this.create.shopname=item.shopname;
      this.create.address=item.address;
      this.chooseShopDialog=false;
    },
    chooseUpdateShopSave(item){
      this.update.shopid=item.id;
      this.update.shopname=item.shopname;
      if(this.update.address=='' || this.update.address==null){
        this.update.address=item.address;
      }
      this.chooseUpdateShopDialog=false;
    },
    
    /** 编辑客户信息 **/
    editCurrent(item){
    	this.$emit('listenchild',{name:'编辑客户',url:'Customeredit',data:item});
    	/**
        this.getClassList();
        this.update.id=item.id;
        this.update.name=item.name;
        this.update.shopid=item.shopid;
        this.update.shopname=item.shopname;
        this.update.simple=item.simple;
        this.update.pym=item.pym;
        this.update.address=item.address;
        this.update.phone=item.phone;
        this.update.receivable=item.receivable;
        this.update.advance=item.advance;
        this.update.maxreceivable=item.maxreceivable;
        this.update.groupid=item.groupid;
        this.update.period=item.period;
        this.update.note=item.note;
        this.update.balance=item.balance;
        this.update.cityids=item.cityids;
        this.update.district_id=item.district_id;
        this.update.district_name=item.district_name;
        this.update.position=item.position;	
        this.update.clerkid=item.clerkid==0 ? '' : item.clerkid;
        
        this.zoom=5;
        this.create.position='';    
        item.lng=='' || item.lng==null ? this.center.lng=116.046671 : this.center.lng=item.lng; //地图中心展示的经度
        item.lat=='' || item.lat==null ? this.center.lat=40.269514 : this.center.lat=item.lat; //地图中心展示的纬度
        
        this.markerPoint.lng=item.lng;    	
    	this.markerPoint.lat=item.lat;    	
        this.updateDialog=true;
        */
    },
    
    /** 更新客户信息 **/
    updateSave(){
      // 主动校验
      this.$refs.update.validate((valid) => {
          if (valid) {
              this.updateLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.update).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.updateLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateDialog=false;
                    this.updateLoading=false;
                    this.getList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.updateDialog=false;
                  this.updateLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    
    //删除
    delCurrent(item){
      this.$confirm('此操作将永久删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' })
              .then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')})
                  .then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.name + '!');
                    this.getList();
                  }
              }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
               });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    },
    //重置分类表单
    resetClass() {
        this.$refs.createclass.resetFields();
    },
    //分类列表
    showClassDialog(){
      this.$emit('listenchild',{name:'客户分类管理',url:'Customercate'});    
      //this.classDialog=true;
      //this.getClassList();
    },
    //新增分类
    createClassSave(){
      // 主动校验
      this.$refs.createclass.validate((valid) => {
          if (valid) {
              this.createClassLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.createclass).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.createClassLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.createClassDialog=false;
                    this.createClassLoading=false;
                    this.resetClass();
                    this.getClassList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createClassDialog=false;
                  this.createClassLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    //分类列表
    getClassList(){
      this.classListLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act:'getclass',token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.classListLoading = false;
        }else{
          this.classlists = JSON.parse(Base64.decode(res.data.Data));
          
          var _this=this;
          this.classlists.forEach(function(e,index){  
          	  e.istype==0 ? _this.istype.splice(index,1,false) : _this.istype.splice(index,1,true);
          	  _this.typelists.splice(index,1,e.discount);
          }); 
          
          this.classListLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.classListLoading=false;
      });
    },
    //显示编辑分类框
    editClassDialog(item){
      this.updateClassDialog=true;
      this.updateclass.id=item.id;
      this.updateclass.groupname=item.groupname;
    },
    //编辑分类的保存
    updateClassSave(){
      // 主动校验
      this.$refs.updateclass.validate((valid) => {
          if (valid) {
              this.updateClassLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.updateclass).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.updateClassLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateClassDialog=false;
                    this.updateClassLoading=false;
                    this.getClassList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createClassDialog=false;
                  this.createClassLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    //删除
    delClass(item){
      this.$confirm('此操作将永久删除 ' + item.groupname + ', 是否继续?', '提示', { type: 'warning' })
              .then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'delclass',id: item.id,token:this.$cookies.get('token')})
                  .then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.groupname + '!');
                    this.getClassList();
                  }
              }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
               });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    },
    
    /** 获取城市列表信息 **/
    getCitys() {
      var resource = this.$resource(this.GLOBAL.domain+"Address/getcitylists");
      resource.query({token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.citys = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    /** 置空客户信息 **/
    setcreatenull() {
        this.create.name='';
        this.create.shopid='';
        this.create.simple='';
        this.create.pym='';
        this.create.address='';
        this.create.phone='';
        this.create.receivable='';
        this.create.advance='';
        this.create.maxreceivable='';
        this.create.groupid='';
        this.create.period='';
        this.create.note='';
        this.create.cityid=[];
    },
    
    /** 获取默认城市信息 **/
    getDefaultcity() {
    	var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
        resource.query({act:'getDefaultcity',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001'){
	            this.$router.push('/login')
	          }
	          this.$message.error(res.data.Message);
	        }else{
	          this.create.cityids = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    //客户区域管理
    districtDialog() {
    	this.$emit('listenchild',{name:'客户区域管理',url:'Customerdistrict'});    
    	//this.createdistrictDialog=true;
    	//this.getdistrictlists();
    },
    
    //客户区域列表
    getdistrictlists() {
    	this.districtlistsLoading=true;
    	var resource = this.$resource(this.url);
    	resource.query(this.disstrictquery).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.districtlistsLoading=false;
	        }else{
	          this.districtlists = JSON.parse(Base64.decode(res.data.Data));
          	  this.district_total_rows=parseInt(res.data.count);
	          this.districtlistsLoading=false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.districtlistsLoading=false;
        });
    },
    
    //选中客户区域信息
    ensuredistrict(obj) {
    	this.create.district_id=obj.id;
    	this.create.district_name=obj.district_name;
    	this.update.district_id=obj.id;
    	this.update.district_name=obj.district_name;
    	this.selectdistrictDialog=false;
    },
    
    //获取客户区域信息列表
    selectdistricts() {
    	this.selectdistrictDialog=true;
		this.getselectdistrictlists();
    },
    
    //选择客户区域列表
    getselectdistrictlists() {
    	this.selectdistrictlistsLoading=true;
    	var resource = this.$resource(this.url);
    	resource.query(this.selectdisstrictquery).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.selectdistrictlistsLoading=false;
	        }else{
	          var data = JSON.parse(Base64.decode(res.data.Data));
	          var _this=this;
	          this.selectdistrict=[];
	          this.selectdistrict.push({id:0,district_name:'不选择区域'});
	          data.forEach(function(e,index) {
	          	  _this.selectdistrict.push(e);
	          });
          	  this.select_district_total_rows=parseInt(res.data.count);
	          this.selectdistrictlistsLoading=false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.selectdistrictlistsLoading=false;
        });
    },
    
    selectdistrictChooseSizeChange(val) {
    	this.selectdisstrictquery.rollpage=val;
    	this.getselectdistrictlists();
    },
    
    selectdistrictChooseCurrentChange(val) {
    	this.selectdisstrictquery.p=val;
    	this.getselectdistrictlists();
    },
    
    //编辑客户区域信息
    editdistrictDialog(obj) {
    	this.editdistrict.id=obj.id;
    	this.editdistrict.name=obj.district_name;
    	this.editdisDialog=true;
    },
    
    //保存编辑客户区域信息
    editdistrictSave() {
    	this.editdistrictLoading=true;
    	var resource = this.$resource(this.url);
    	resource.query(this.editdistrict).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.editdistrictLoading=false;
	        }else{
	          this.$message.success('编辑区域：'+this.editdistrict.name+'成功!');
	          this.editdistrictLoading=false;
	          this.editdisDialog=false;
	          this.getdistrictlists();
	          //更新搜索页区域信息
	          this.getsearchdistrictlsits();
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.editdistrictLoading=false;
	        this.editdisDialog=false;
        });
    },
    
    //保存客户区域
    districtSave() {
    	if(this.adddistrict.name=='' || this.adddistrict.name==null) {
    		this.$message.error('请填写区域名称！');
    		return false;
    	}
    	
    	this.adddistrictLoading=true;
    	var resource = this.$resource(this.url);
    	resource.query(this.adddistrict).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.adddistrictLoading=false;
	        }else{
	          this.$message.success('区域：'+this.adddistrict.name+'添加成功!');
	          this.adddistrictLoading=false;
	          this.addistrictDialog=false;
	          this.adddistrict.name='';
	          this.getdistrictlists();
	          this.getselectdistrictlists();
	          //更新搜索页区域信息
	          this.getsearchdistrictlsits();
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.adddistrictLoading=false;
	        this.addistrictDialog=false;
        });
    },
    
    //删除区域
    deldistrict(item){
        this.$confirm('此操作将永久删除 ' + item.district_name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'deldistrict',id:item.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.district_name + '!');
                    this.getdistrictlists();
                    //更新搜索页区域信息
	          	    this.getsearchdistrictlsits();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
              });
        }).catch(() => {
              this.$message.info('已取消操作!');
        });
    },
    
    //查看用户是否有权限打开所属店铺
    getisshowselectshop() {
    	var resource = this.$resource(this.url);
        resource.save({ act:'getisshowshop',managerid:this.$cookies.get('managerid'),token:this.$cookies.get('token')}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
            	this.isshowshop=Base64.decode(res.data.Data);
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 预存款充值列表 **/
    depositCurrent(obj) {
    	this.$emit('listenchild',{name:obj.simple+'预存款充值',url:'Customerdeposit',data:obj});     
    	//this.depositname=obj.simple+'预存款充值消费信息';
    	//this.depositDialog=true;
    	//this.depositbalance=0;
		//this.depositbalance=obj.balance;
		
		//获取预存款记录
		//this.deposit.customerid=obj.id;
		//this.savedeposit.customerid=obj.id;
		//this.savedeposit.balance=0.00;
		//this.savedeposit.node='';
		//this.getdeposit();		
    },
    
    
    /** 获取客户预存款记录 **/
    getdeposit() {
    	this.depositLoading=true;      
        var resource = this.$resource(this.url);
    	resource.query(this.deposit).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.depositLoading=false;
	        }else{
	          this.depositlists=JSON.parse(Base64.decode(res.data.Data));
	          this.deposit_total_rows=parseInt(res.data.count);
	          this.depositLoading=false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.depositLoading=false;
        });
    },
    
    
    /** 预存款充值 **/
    adddeposit() {
    	this.addpositDialog=true;
    },
    
    /** 添加预存款 **/
    depositSave() {
    	this.addpositLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.savedeposit).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
            	this.addpositLoading=false;
                this.$message.error(res.data.Message);
            }else{
            	this.addpositLoading=false;
            	this.addpositDialog=false;
            	this.getdeposit();
            	this.depositbalance=res.data.Message;
            	this.$message.success('预存款添加成功！');
            }
        }).catch((res) => {
        	this.addpositLoading=false;
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取店铺当前的位置 **/
    getmapinfos() {  
    	this.zoom=5;
    	this.initLocation = true;
    	this.showmapDialog=true;    	
    },
    
    /** 返回中心位置 **/
    gobackcenter() {
    	this.center.lng=116.046671; //地图中心展示的经度
        this.center.lat=40.269514; //地图中心展示的纬度  	
    },
    
    /** 检索完成回调函数  **/
    markersset(e) {    
    	this.maplocation='';
    },
    
    /** 获取当前位置经纬度 **/
    getlocalposition(e) {
    	this.zoom = e.target.getZoom();  	
    	this.markerPoint.lng=e.point.lng;    	
    	this.markerPoint.lat=e.point.lat;
    },
    
    /** 保存选取的经纬度 **/
    savelocation() {
    	this.showmapDialog=false;
    	if(this.markerPoint.lng=='') {this.$message.error("请选择您的位置");return false;}
    	this.create.position=this.markerPoint.lat+","+this.markerPoint.lng;
    	this.update.position=this.markerPoint.lat+","+this.markerPoint.lng;
    	this.update.lng=this.markerPoint.lng;
    	this.update.lat=this.markerPoint.lat;
    },
    
    /** 选择折扣方式(打折/商品会员价) **/
    changedistype(index,obj) {
    	var isdiscount=0;
    	this.istype[index] ? isdiscount=1 : isdiscount=0;
		
        var resource = this.$resource(this.url);
        resource.save({act:'changerebate',id:obj.id,isdiscount:isdiscount,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
            	this.$message.error(res.data.Message);
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 修改折扣 **/
    changerate(index,item) {
    	var rate=this.typelists[index];
    	
    	var resource = this.$resource(this.url);
        resource.save({act:'changerete',id:item.id,rate:rate,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
            	this.$message.error(res.data.Message);
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },     
    
    //批量添加客户信息
    addmoreDialog() {
    	this.$emit('listenchild',{name:'批量新增客户',url:'Customermoreadd'});
    	//this.morecustomerDialog=true;
    },
    
    //下载批量导入数据模板
    getdownmoremodel() {
    	location.href=this.GLOBAL.domain+"ChangeFile/getcustomerexport";
    },
    
    //上传模板数据
    getaddmoremodel() {
    	document.getElementById("fileupload").click();
    },
    
    
    /************** 导入excel表格数据 **************/
    importfile(obj) {    
    	let _this = this;
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file = event.currentTarget.files[0];                
        var rABS = false; //是否将文件读取为二进制字符串
        var f = this.file;
        var outdata;
        var reader = new FileReader();
        FileReader.prototype.readAsBinaryString = function(f) {
        	var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload').value = null;
                
                //提交数据到后台
                _this.inputlistLoading=true;
        		var resource = _this.$resource(_this.url);
                resource.save({act:'inputinfos',infos:outdata,token:_this.$cookies.get('token')}).then((res) => {
                    if(res.data.Result>0){
                    	if(res.data.Result=='70001') this.$router.push('/login')
                    	_this.inputlistLoading=false;
                    	_this.$message({
				    		dangerouslyUseHTMLString: true,
				    		type:'error',
				    		message:'<span style="line-height:20px">'+res.data.Message+'</span>',
			    		});
                    }else{
                    	_this.inputcustomers=JSON.parse(Base64.decode(res.data.Data));
                    	_this.inputlistLoading=false;
                  	}
                }).catch((res) => {
                    _this.inputlistLoading=false;
                });        
                           
            }
            reader.readAsArrayBuffer(f);
        }
               
        if(rABS) {
        	reader.readAsArrayBuffer(f);
        } else {
            reader.readAsBinaryString(f);
        }
                  
    },
    /************* 导入excel表格数据 *****************/
    
    //保存批量导入会员信息
    createmoreSave() {
    	this.createmoreLoading=true;
    	var resource = this.$resource(this.url);
        resource.save({act:'saveinput',token:this.$cookies.get('token'),data:this.inputcustomers}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
            	this.createmoreLoading=false;
            	this.$message.error(res.data.Message);
            }else {
            	this.$message.success("批量导入客户信息成功");
            	this.createmoreLoading=false;
            	this.morecustomerDialog=false;
            	this.getList();
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 管理等级 **/
    levelDialog() {
    	this.$emit('listenchild',{name:'客户等级管理',url:'Customerlevel'});
    }, 
    
    
    /** 导出客户信息 **/
    getexportcustomer() {
    	this.exportdataDialog=true;
    	this.exportdataLoading=true;
    	var resource = this.$resource(this.GLOBAL.exportUrl+'Customer/index');
	    resource.query({act:'exportcustomer',token:this.$cookies.get('token'),district_id:this.query.district_id,groupid:this.query.groupid,clerkid:this.query.clerkid,key:this.query.key,isexport:1}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.exportdataLoading=false;
	        }else{
	            this.exportcustomers = JSON.parse(Base64.decode(res.data.Data));
	            this.exportdataLoading=false;    
	        }
	    }).catch((res) => {
	          this.exportdataLoading=false; 
	    });
    },
    
    
    //导出客户数据
    productoutput() {
    	this.exporthead=['区域','客户名称','客户编号','客户电话','客户地址','客户分类','销售员'];
	    this.exportfield=['district_name','name','number','phone','address','groupname','clerkname'];
	    this.exportlists=this.exportcustomers;
	    this.exportname='客户信息';
	    this.exportput();
	    this.exportdataDialog=false;		
    },
    
    /** 确认导出信息 **/
    exportput() {
		require.ensure([], () => {
			var { export_json_to_excel } = require('../../vendor/Export2Excel');
			var data = this.formatJson(this.exportfield, this.exportlists);
			export_json_to_excel(this.exporthead, data, this.exportname);
		})
    },
    
    //导出表格数据
	  formatJson(filterVal, jsonData) {
　　　　return jsonData.map(v => filterVal.map(j => v[j]));
　　},


    /** 将客户数据提交至金蝶 **/
	  kingdeesellsubmit(item) {
      this.$confirm('警告：操作前请确认该客户是否已完结无需修改，数据一经提交至金蝶成功不可撤销', '提示', { type: 'warning' }).then(() => {
            var resource = this.$resource(this.url);
            resource.query({act:'kingdeesubmit',id:item.id,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
              }else{
                this.getList();
                this.$message.success('客户数据提交到金蝶成功');      
              }
            }).catch((res) => {
                
            });
        }).catch(() => {
                
        });
	  },


    /** 查看客户的跑店记录 **/
    lookruns(item) {
      this.$emit('listenchild',{name:'职员跑店记录',url:'Clerkrun',data:{id:item.id,name:item.name+' - '+item.simple}});
    },  


    /** 合并客户信息 **/
    mergecustomer() {
      this.mergeDialog=true;
      this.mergequery.oldid='';
      this.mergequery.olddata={};
      this.mergequery.newid='';
      this.mergequery.newdata={};
    },


    /** 获取要合并的客户信息 **/
    getmergecustomer(type) {
      this.mergecustomerDialog=true;
      this.mergecustomerquery.mergetype=type;
      this.mergecustomerquery.key='';
      this.mergecustomerquery.p=1;
      this.mergecustomerquery.rollpage=10;
      this.getmergecustomerdata();
    },

    /** 获取合并的客户信息列表 **/
    getmergecustomerdata() {
      if(this.mergechange) {
        this.mergecustomerquery.p=1;
        this.mergecustomerquery.rollpage=10;
      }

      var ids=[];
      this.mergequery.oldid > 0 ? ids.push(this.mergequery.oldid) : '';
      this.mergequery.newid > 0 ? ids.push(this.mergequery.newid) : '';
      this.mergecustomerquery.ids=ids;
      this.mergecustomerquery.loading=true;
      var resource = this.$resource(this.url);
      resource.save(this.mergecustomerquery).then((res) => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.mergecustomerquery.loading=false;
        }else{
            this.mergecustomerlists=JSON.parse(Base64.decode(res.data.Data));
	          this.merge_rows=parseInt(res.data.count);
            this.mergecustomerquery.loading=false;  
            if(this.mergechange) this.mergechange=false; 
        }
      }).catch((res) => {
          this.mergecustomerquery.loading=false;      
      });
    },

    mergepageSizeChange(val) {
        this.mergecustomerquery.rollpage = val;
        this.getmergecustomerdata();
    },
    mergepageCurrentChange(val) {
        this.mergecustomerquery.p = val;
        this.getmergecustomerdata();
    },

    //选择客户
    selectcustomer(item) {
        this.mergecustomerDialog=false;
        if(this.mergecustomerquery.mergetype==1) {
            this.mergequery.oldid=item.id;
            var data={name:item.name,sells:item.sells,refunds:item.refunds};
            this.mergequery.olddata=data;

        }else {
            this.mergequery.newid=item.id;
            var data={name:item.name,sells:item.sells,refunds:item.refunds};
            this.mergequery.newdata=data;

        }
    },

    //转换两客户之间的位置
    changecustomer() {
      var id=this.mergequery.oldid;
      var data=this.mergequery.olddata;

      this.mergequery.oldid=this.mergequery.newid;
      this.mergequery.olddata=this.mergequery.newdata;
      this.mergequery.newid=id;
      this.mergequery.newdata=data;
    },

    /** 保存合并客户信息 **/
    savemerge() {
        this.$confirm('警告：该操作会将待合并客户下的所有销售出库单、商品退货单信息的客户信息变更为保留客户，并删除待合并客户信息，且该操作不可撤销', '提示', { type: 'warning' }).then(() => {
            var resource = this.$resource(this.url);
            resource.save(this.mergequery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.mergeDialog=false;
                  this.getList();
              }
            }).catch((res) => {
                     
            });

        }).catch(() => {
                
        });
    },

       
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.serachinput {width:300px;height:30px;background-color:#fff;background-image:none;border-radius:4px;border:1px solid #dcdfe6;box-sizing:border-box;color:#606266;display:inline-block;font-size:inherit;height:40px;line-height:40px;outline:0;padding:0 15px;box-shadow:1px 4px 11px #cdcdcd}
.merge-custoers-notice {border-radius:6px;border:1px solid rgb(221,221,221,.8);background:rgb(221,221,221,.7);padding:10px;color:red;font-size:12px;line-height:20px}
.merge-customer {float:left;width:100%;margin-top:20px;margin-bottom:20px}
.merge-main {float:left;width:49%;min-height:60px;border-right:1px dashed #dddddd;border-top:1px solid #dddddd;border-left:1px solid #dddddd;border-bottom:1px solid #dddddd;border-radius:5px 0 0 5px;text-align:center}
.merge-other {float:left;width:50%;min-height:60px;border-top:1px solid #dddddd;border-right:1px solid #dddddd;border-bottom:1px solid #dddddd;border-radius:0 5px 5px 0;text-align:center}
.merge-main .merge-title,.merge-other .merge-title {float:left;width:90%;padding:3px 5%;font-size:13px;background:#dddddd;color:#333336;}
.merge-main .mergecontent,.merge-other .mergecontent {float:left;width:100%;padding:30px 0;cursor:pointer}
.merge-main .nomerge,.merge-other .nomerge {float:left;width:100%;text-align:center;font-size:13px;padding:5px 0}

.cz-customer-infos-out {float:left;width:100%}
.cz-customer-infos-out .cz-customer-infos-out-imgs {float:left;width:50px;height:50px;padding:2px;border-radius:50%;border:1px solid rgba(221,221,221,.6);background:#F2F6FC;position:relative;}
.cz-customer-infos-out img {float:left;width:100%;border-radius:50%}
.cz-customer-data-from {position:absolute;top:0;left:0;}
.cz-customer-data-from img {float:left;width:22px;height:22px;border-radius:50%;margin-left:-5px;}

.cz-customer-infos-content {float:left;width:calc(100% - 60px - 2px - 10px);height:60px;margin-left:10px;}
.cz-customer-infos-content .cz-customer-infos-main {float:left;width:100%}
.cz-customer-infos-content .cz-customer-infos-main-name {float:left;width:100%;font-size:13px;line-height:21px;font-weight:300;}
.cz-customer-infos-content .cz-customer-infos-main-phone {float:left;width:100%;font-size:12px;line-height:21px;font-weight:300;color:#999999;}
.cz-customer-infos-content .cz-customer-infos-main-district {float:left;width:100%;font-size:12px;line-height:21px;font-weight:300;color:#999999;}
.cz-customer-infos-cate {float:left;width:100%;height:30px;display:flex;justify-content:left;align-items:center;}
.cz-customer-infos-cate img {width:17px;height:17px}
.cz-customer-infos-cate span {float:left;font-size:13px;line-height:21px;color:#666666;margin-left:10px;}
.cz-customer-infos-cate-address {float:left;width:100%;display:flex;justify-content:left;align-items:center;padding-bottom:5px}
.cz-customer-infos-cate-address img {width:17px;height:17px}
.cz-customer-infos-cate-address span {float:left;font-size:12px;line-height:21px;color:#666666;margin-left:10px;}
</style>


// WEBPACK FOOTER //
// src/components/base/Customer.vue